var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mpage"},[_c('h3',[_vm._v("扫码关注公众号")]),_c('div',[_c('img',{attrs:{"src":_vm.document.domain+_vm.document.ewm,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }